import React from 'react'
import styles from './styles.module.css'
import useDelete from './useDelete'
import sleep from '@helpers/misc/sleep'
import {sendPosthogData, EVENTS} from '@helpers/posthog'

export default function Delete(props) {
  const {close, cartItem} = props
  const deleteItem = useDelete()
  const remove = async () => {
    try {
      sendPosthogData(EVENTS.clicked.cartRemoveProduct)
      close()
      await sleep(200)
      await deleteItem(cartItem._id)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className={styles.container}>
      <a className={styles.button} onClick={remove}>
        Eliminar
      </a>
    </div>
  )
}
